var CustomCollectionFilterModel = /** @class */ (function () {
    function CustomCollectionFilterModel(filterType, title, options) {
        this.filterType = filterType;
        this.activeOptions = [];
        this.selectedOptions = [];
        this.title = title;
        this.options = options;
    }
    CustomCollectionFilterModel.prototype.updateActiveOptions = function (optionId) {
        if (this.activeOptions.indexOf(optionId) === -1) {
            this.activeOptions.push(optionId);
        }
        else {
            var index = this.activeOptions.indexOf(optionId);
            this.activeOptions.splice(index, 1);
        }
    };
    CustomCollectionFilterModel.prototype.hasActiveCollectionIds = function () {
        return !!this.activeOptions.length;
    };
    CustomCollectionFilterModel.prototype.resetActiveOptions = function () {
        this.activeOptions = [];
        this.selectedOptions = [];
    };
    return CustomCollectionFilterModel;
}());
export { CustomCollectionFilterModel };
//# sourceMappingURL=CustomCollectionFilterModel.js.map